import { criarFinalizador } from '@/uteis/action/devolver/finalizador'

export const desfazer = (dados, dadosSessao) => {
  var eliminacao = {
    ...dados,
    participante: criarFinalizador(dadosSessao, true)
  }

  return eliminacao
}
